import React from 'react';
import styled from 'styled-components';
import { Header4Text, IGroupedNavigationOptions, INavigationItemProps, NavigationItem } from 'ui-toolkit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faKey,
  faUser,
  faUsersCrown,
  faFileInvoiceDollar,
  faEarthAmerica,
  faTag,
} from '@fortawesome/pro-regular-svg-icons';
import { nbsp } from '../../../utilities/administration/magicStrings';

const MenuCard = styled.div`
  display: grid;
  background-color: ${(props) => props.theme.colors.defaultContentBackground};
  border: 1px solid ${(props) => props.theme.colors.defaultContentBorder};
  gap: ${(props) => props.theme.spacing.spacing5};
  vertical-align: top;
  padding: ${(props) => props.theme.spacing.spacing5};
`;
const MenuItem = styled(NavigationItem)`
  display: flex;
  align-items: center;
  padding-left: ${(props) => props.theme.spacing.spacing5};
  padding-bottom: ${(props) => props.theme.spacing.spacing2};
  padding-top: ${(props) => props.theme.spacing.spacing2};
  margin: 2px;
  :hover {
    color: ${(props) => props.theme.colors.defaultContentBackground};
  }
`;

const faIconDict = {
  Users: faUser,
  Roles: faUsersCrown,
  Permissions: faKey,
  Pricing: faFileInvoiceDollar,
  Global: faEarthAmerica,
  'By Role': faUsersCrown,
  'By User': faUser,
  Tags: faTag,
};

const MenuNavButton: React.FC<INavigationItemProps> = (props) => {
  return (
    <MenuItem {...props} isInline appearance={'minimal'} intent={'primary'}>
      <FontAwesomeIcon icon={faIconDict[props.text]} />
      {`${nbsp}${props.text}`}
    </MenuItem>
  );
};

export const LeftSideAdministrationMenu: React.FC<{ url: string }> = ({ url }) => {
  return (
    <MenuCard>
      {administrationNavigationOptions(url).map((section) => (
        <React.Fragment key={section.group}>
          <Header4Text>{section.group}</Header4Text>
          {section.navigationOptions.map((option) => (
            <MenuNavButton key={option.text} {...option} />
          ))}
        </React.Fragment>
      ))}
    </MenuCard>
  );
};

export const administrationNavigationOptions = (basePath: string): IGroupedNavigationOptions[] => [
  {
    group: 'User Management',
    navigationOptions: [
      {
        text: 'Users',
        to: `${basePath}/users`,
      },
      {
        text: 'Roles',
        to: `${basePath}/roles`,
      },
    ],
  },
  {
    group: 'Workflow',
    navigationOptions: [
      {
        text: 'Pricing',
        to: `${basePath}/pricing`,
      },
      {
        text: 'Tags',
        to: `${basePath}/tags`,
      },
    ],
  },
  {
    group: 'Features',
    navigationOptions: [
      {
        text: 'Global',
        to: `${basePath}/features`,
      },
      {
        text: 'By Role',
        to: `${basePath}/features-by-role`,
      },
      {
        text: 'By User',
        to: `${basePath}/features-by-user`,
      },
    ],
  },
];
